import Accounts from '../pages/Accounts/Accounts';
import Commodity from '../pages/Commodity/Commodity';
import ContactPage from '../pages/Contacts/ContactPage';
import ContactsTable from '../pages/Contacts/ContactsTable';
import Dashboard from '../pages/Dashboard/Dashboard';
import EmployeePage from '../pages/Employees/EmployeePage';
import EmployeesTable from '../pages/Employees/EmployeesTable';
import Profile from '../pages/Profile/Profile';
import ChangePassword from '../pages/Signin/ChangePassword';
import RecoveryPassword from '../pages/Signin/RecoveryPassword';
import Signin from '../pages/Signin/Signin';
import RequestCreateContainer from '../pages/Support/RequestCreateContainer';
import RequestEditEntry from '../pages/Support/RequestEditEntry';
import RequestItem from '../pages/Support/RequestItem';
import RequestList from '../pages/Support/RequestList';
import PublicRequests from '../pages/PublicRequests/PublicRequests';
import TurnoverContactCreate from '../pages/TurnoverContactCreate/TurnoverContactCreate';
// import Stock from '../pages/Stock/Stock';

const mainRoutes = [
  {
    path: '/',
    exact: true,
    component: Dashboard,
  },
  {
    path: '/signin',
    exact: true,
    component: Signin,
  },
  {
    path: '/recovery-password',
    exact: true,
    component: RecoveryPassword,
  },
  {
    path: '/restore-password',
    exact: true,
    component: ChangePassword,
  },
  {
    path: '/requests',
    exact: true,
    component: RequestList,
  },
  {
    path: '/create-request',
    component: RequestCreateContainer,
    exact: true,
  },
  // {
  //   path: '/create-skd',
  //   component: RequestSKD,
  //   exact: true,
  // },
  {
    path: '/edit-request/:id',
    component: RequestEditEntry,
    exact: true,
  },
  {
    path: '/requests/:id',
    component: RequestItem,
    exact: true,
  },
  {
    path: '/guest-requests',
    component: PublicRequests,
    exact: true,
  },
  // {
  //   path: '/marketing',
  //   component: Marketing,
  //   exact: true,
  // },
  {
    path: '/profile',
    exact: true,
    component: Profile,
  },
  {
    path: '/accounts',
    exact: true,
    component: Accounts,
  },
  {
    path: '/employees',
    exact: true,
    component: EmployeesTable,
  },
  {
    path: '/employees/create',
    component: EmployeePage,
    exact: true,
  },
  {
    path: '/employees/edit/:id',
    component: EmployeePage,
    exact: true,
  },
  {
    path: '/contacts',
    exact: true,
    component: ContactsTable,
  },
  {
    path: '/contacts/create',
    component: ContactPage,
    exact: true,
  },
  {
    path: '/contacts/edit/:id',
    component: ContactPage,
    exact: true,
  },
  {
    path: '/commodity-circulation',
    exact: true,
    component: Commodity,
  },
  {
    path: '/create-turnover-contact',
    component: TurnoverContactCreate,
    exact: true,
  },
  // {
  //   path: '/stock',
  //   exact: true,
  //   component: Stock,
  // },
];

export default mainRoutes;
